import { render, staticRenderFns } from "./QuickItemListView.vue?vue&type=template&id=6501fec5"
import script from "./QuickItemListView.vue?vue&type=script&lang=js"
export * from "./QuickItemListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports